import { NgModule } from "@angular/core";
import { AgGridModule } from "ag-grid-angular";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ProduktvalModule } from "~app/features/planera/produktval/produktval.module";
import { ArbetsorderProduktvalProduktionsmallComponent } from "./arbetsorder-produktval-produktionsmall/arbetsorder-produktval-produktionsmall.component";
import { ArbetsorderProduktvalSummaryComponent } from "./arbetsorder-produktval-summary/arbetsorder-produktval-summary.component";
import { ArbetsorderProduktvalComponent } from "./arbetsorder-produktval.component";
import { ArbetsorderProduktvalService } from "./arbetsorder-produktval.service";

@NgModule({
    imports: [
        RaskCommonModule,
        ProduktvalModule,
        AgGridModule,
        ArbetsorderProduktvalComponent,
        ArbetsorderProduktvalSummaryComponent,
        ArbetsorderProduktvalProduktionsmallComponent
    ],
    providers: [ArbetsorderProduktvalService],
    exports: [
        ArbetsorderProduktvalComponent,
        ArbetsorderProduktvalSummaryComponent,
        ArbetsorderProduktvalProduktionsmallComponent
    ]
})
export class ArbetsorderProduktvalModule { }
